import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

import { QuarantineApi } from '@Apis';
import { QuarantineLogTypeEnum } from '../../../types/log';
import { QUARANTINE_TYPE_NAME_MAP } from '../utils/constants';
import { QuarantineDeleteActionReqDto } from '../utils/types';
import { QuarantineItemModalName, QuarantineItemModalState } from './interface';
import { getQuarantineDeleteActionURL } from '../utils/fns';
import LoadingBtn from '../../../components/Common/LoadingBtn';

export function DeleteModal({
  quarantineType,
  modal,
  setModal,
  setTrigger,
}: {
  quarantineType: QuarantineLogTypeEnum;
  modal: QuarantineItemModalState;
  setModal: ({ name, quarantineItems }: QuarantineItemModalState) => void;
  setTrigger: () => void;
}) {
  const { t } = useTranslation();

  const onClose = () => {
    setModal({
      name: QuarantineItemModalName.None,
      quarantineItems: modal.quarantineItems,
    });
  };

  const onClick = async () => {
    const data: QuarantineDeleteActionReqDto = {
      itemList: [] as any[],
    };
    const url = getQuarantineDeleteActionURL(quarantineType);
    try {
      if (url === 'spod/delete') {
        data.serviceName = QUARANTINE_TYPE_NAME_MAP.get(
          quarantineType
        ) as string;
        modal.quarantineItems.forEach((_item) => {
          data.itemList.push({
            uniqueId: _item.uniqueId || '',
            uniqueLogId: _item.uniqueLogId,
            quarantineType: _item.quarantineTypeKey,
            traceId: _item.traceId,
            index: _item.index,
            type: _item.type,
            id: _item.id,
            dedicatedSite: _item.dedicatedSite,
            violator: _item.violator,
            companyGuid: _item.companyGuid,

            siteUrl: _item.siteUrl,
            graphSiteId: _item.graphSiteId,
            useSpodtmDelegator: _item.useSpodtmDelegator || 'false',

            originalDriveId: _item.originalDriveId || '',
            originalParentId: _item.originalParentId || '',
            originalId: _item.originalId || '',
            fileName: (_item as any).fileNamePath[_item.uniqueId],
            fileOriginalPath: _item.fileOriginalPath || '',

            quarantineDriveId: _item.quarantineDriveId || '',
            quarantineParentId: _item.quarantineParentId || '',
            quarantineItemId: _item.quarantineItemId || '',
            quarantineFileName: _item.quarantineFileName || '',
            notificationFileId: _item.notificationFileId || '',
          });
        });
        data.serviceName = QUARANTINE_TYPE_NAME_MAP.get(
          quarantineType
        ) as string;
      } else if (url === 'exchangeOnline/delete') {
        modal.quarantineItems.forEach((_item) => {
          data.itemList.push({
            msgReceivedTime: _item.msgReceivedTime,
            uniqueId: _item.uniqueId,
            uniqueLogId: _item.uniqueLogId,
            emailAddress: _item.violator,
            traceId: _item.traceId,
            index: _item.index,
            type: _item.type,
            id: _item.id,
            violator: _item.violator,
            companyGuid: _item.companyGuid,
            protectionMode: _item.protectionMode,
            msgFrom: _item.msgFrom,
            msgTo: _item.msgTo,
            msgSubject: _item.msgSubject,
            messageId: _item.messageId,
            folder: _item.folderPath,
          });
        });
      } else if (url === 'cloudApp/delete') {
        modal.quarantineItems.forEach((_item) => {
          data.itemList.push({
            logTimestamp: new Date(_item.timestamp).toISOString(),
            uniqueLogId: _item.uniqueLogId,
            uniqueFileId: _item.uniqueId,
            violatorId: _item.violatorId,
            folderId: _item.folderId,
            fileName: _item.fileName,
            resourceId: _item.resourceId,
            isShared: _item.isShared,
            shareSetting: _item.shareSetting,
            violator: _item.violator,
            companyGuid: _item.companyGuid,
            rootNodeId: _item.rootNodeId,
          });
        });
        data.serviceName = QUARANTINE_TYPE_NAME_MAP.get(
          quarantineType
        ) as string;
      } else if (url === 'teams/delete') {
        modal.quarantineItems.forEach((_item) => {
          data.itemList.push({
            uniqueId: _item.uniqueId || '',
            uniqueLogId: _item.uniqueLogId,
            quarantineType: _item.quarantineTypeKey,
            traceId: _item.traceId,
            index: _item.index,
            type: _item.type,
            id: _item.id,
            violator: _item.violator,
            companyGuid: _item.companyGuid,

            siteUrl: _item.siteUrl,
            graphSiteId: _item.graphSiteId,
            useSpodtmDelegator: _item.useSpodtmDelegator || 'false',

            originalDriveId: _item.originalDriveId || '',
            originalParentId: _item.originalParentId || '',
            originalId: _item.originalId || '',
            fileName: _item.fileName,
            fileOriginalPath: _item.fileOriginalPath || '',

            quarantineDriveId: _item.quarantineDriveId || '',
            quarantineParentId: _item.quarantineParentId || '',
            quarantineItemId: _item.quarantineItemId || '',
            quarantineFileName: _item.quarantineFileName || '',
            notificationFileId: _item.notificationFileId || '',
          });
        });
      } else if (url === 'exchangeServer/delete') {
        modal.quarantineItems.forEach((_item) => {
          data.itemList.push({
            uniqueId: _item.uniqueId,
            messageId: _item.messageId,
            uniqueLogId: _item.uniqueLogId,
            smexServerFqdn: _item.productServerName,
            index: _item.index,
            type: _item.type,
            id: _item.id,
            companyGuid: _item.companyGuid,
            violator: _item.productServerName,
          });
        });
      } else if (url === 'gmail/delete') {
        modal.quarantineItems.forEach((_item) => {
          data.itemList.push({
            logDocId: _item.id,
            logId: _item.uniqueLogId,
            logIndexId: _item.index,
            logType: _item.type,
            uniqueId: _item.uniqueId,
            violator: _item.violator,
            messageId: _item.messageId,
            internetMessageId: _item.internetMessageId,
            folder: _item.folderPath,
            msgFrom: _item.msgFrom,
            msgTo: _item.msgTo,
            msgSubject: _item.msgSubject,
            companyGuid: _item.companyGuid,
            dedicatedMailbox: _item.msgDedicatedQuarantineMailbox,
          });
        });
      }
      await QuarantineApi.apiDeleteQuarantineLogs(url, data);
      window.showNotification({
        titleMsg: t('quarantine.modal.action.successInfo'),
        severity: 'success',
      });
      setModal({
        name: QuarantineItemModalName.None,
        quarantineItems: [],
      });
      setTrigger();
    } catch {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
      onClose();
    }
  };
  if (modal.name !== QuarantineItemModalName.Delete) {
    return <></>;
  }
  return (
    <Modal
      closeOnEsc
      closeOnOutsideClick
      isClosable
      isOpen={modal.name === QuarantineItemModalName.Delete}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay />
      <ModalContent width={480}>
        <ModalBody>
          <Text mb="4x">{t('quarantine.modal.delete.desc')}</Text>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn variant="primary" minWidth="20x" onClick={onClick}>
            {t('common.button.ok')}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
